import { render, staticRenderFns } from "./ApprovalSetup.vue?vue&type=template&id=1f7abda8&scoped=true&"
import script from "./ApprovalSetup.vue?vue&type=script&lang=js&"
export * from "./ApprovalSetup.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalSetup.vue?vue&type=style&index=0&id=1f7abda8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7abda8",
  null
  
)

export default component.exports